import React, { useEffect } from 'react'
import { flushSync } from 'react-dom'

import produce from 'immer'
import { DataTableState } from 'primereact/datatable'
import { useLocalstorageState, useSessionstorageState } from 'rooks'

import { Constants } from '../../utils/constants'

export const PrintHandler: React.FC = () => {
  const [panelState, setPanelState] = useLocalstorageState<{
    [key: string]: boolean
  }>(Constants.LOCAL_STORAGE_PANELS_KEY, {})
  const [tableState, setTableState] = useSessionstorageState<{
    [key: string]: DataTableState
  }>(Constants.SESSION_STORAGE_TABLE_KEY, {})

  const initialPanelState = produce(panelState, () => {})
  const initialTableState = produce(tableState, () => {})

  const handlePrint = () => {
    handleBeforePrint()
    window.print()
    handleAfterPrint()
  }

  const handleBeforePrint = () => {
    flushSync(() => {
      // Show all table rows and start at the first page
      let updatedTableState = produce(tableState, (draft: any) => {
        for (let key of Object.keys(tableState)) {
          draft[key].first = 0
          draft[key].rows = Constants.MAX_ROWS_FOR_PRINT
        }
      })

      setTableState(updatedTableState)

      // Open all panels
      let updatedState = produce(panelState, (draft: any) => {
        for (let key of Object.keys(panelState)) draft[key] = false
      })

      setPanelState(updatedState)
    })
  }

  // Set tables and panels back to initial state like it was before printing
  const handleAfterPrint = () => {
    setTableState(initialTableState)
    setPanelState(initialPanelState)
  }

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Check keyboard shortcuts for printing
      if ((event.metaKey || event.ctrlKey) && event.key === 'p') {
        event.preventDefault()
        event.stopPropagation()
        handlePrint()
      }
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [handlePrint])

  return <></>
}
